import PetriNetRuleProvider from "./controller";

export default {
    __init__: ['petriNetRules'],
    petriNetRules: ['type', PetriNetRuleProvider]
};